import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormTimePicker,
  HubMaterialHookSelect,
} from "../../../components";
import { StyledHubCardStack } from "../styles";
import { useHighlightableField } from "../../../hooks";

const gap = "10px";
const columnGap = "10px";

const PartAssembly = ({ basePath }) => {
  const { HighlightMenu, getFieldProps } = useHighlightableField();
  const p = `${basePath}.routing.0`;
  const cp = `${basePath}.config`;

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Assembly Details</Typography>
        <Stack gap="25px">
          <Stack direction="row" gap={columnGap}>
            <HubMaterialHookSelect
              type="trees"
              label="Tree Type"
              name={`details.treeId`}
              useDefault
              {...getFieldProps(`${cp}.treeId`)}
            />
            <HubHookFormInput
              name={`details.partsPerTree`}
              label="Parts / Tree"
              placeholder="Ex. 12"
              required
              isNumber
              {...getFieldProps(`${cp}.partsPerTree`)}
            />
            <HubHookFormInput
              name={`${cp}.treesPerCluster`}
              label="Trees / Cluster"
              placeholder="Ex. 12"
              isNumber
              {...getFieldProps(`${cp}.treesPerCluster`)}
            />
            <HubHookFormInput
              name={`${cp}.setup`}
              label="Setup"
              placeholder="Setup..."
              {...getFieldProps(`${cp}.setup`)}
            />
          </Stack>
          <Stack direction="row" gap={columnGap}>
            <HubHookFormTimePicker
              name={`${p}.leadTime`}
              label="Lead Time"
              placeholder="Ex. 12"
              fields={["days"]}
              required
              {...getFieldProps(`${p}.leadTime`)}
            />
            <HubHookFormTimePicker
              name={`${p}.cycleTime`}
              label="Cycle Time"
              placeholder="Ex. 0.24"
              required
              {...getFieldProps(`${p}.cycleTime`)}
            />
            <HubHookFormInput
              name={`${cp}.weight`}
              label="Tree Weight"
              placeholder="ex. 4.55"
              endAdornment="lbs"
              isDecimal
              {...getFieldProps(`${cp}.weight`)}
            />
          </Stack>
        </Stack>
      </Stack>
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Assembly Notes</Typography>
        <HubHookFormInput
          name={`${basePath}.notes`}
          label="Special Instructions"
          placeholder="Notes..."
          rows={5}
          multiline
          {...getFieldProps(`${basePath}.notes`)}
        />
      </Stack>
      {HighlightMenu}
    </StyledHubCardStack>
  );
};

export default PartAssembly;
